import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const FooterEnd: React.FC = () => {

    return (
        <>
            <Footer style={{ textAlign: 'center' }}>
            </Footer>
        </>
    );
};

export default FooterEnd;
